var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('TableComponent',{attrs:{"section":"client.Client","sectionRoot":"client_list","moduleName":"Client"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }